import * as Sentry from '@sentry/react'

const PROD_DSN =
  'https://e38dec5f861691af9c07c47a57da4262@o4512350493343744.ingest.de.sentry.io/4512350541709392'

const dsn = import.meta.env.VITE_SENTRY_DSN ?? (import.meta.env.PROD ? PROD_DSN : undefined)

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    // Заголовки, тела запросов и cookies содержат токены и персональные данные
    dataCollection: {
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
    },
  })
}

let sessionDropReported = false

/** Один отчёт на страницу: после выкидывания идёт редирект, повторные вызовы — следствие того же события. */
export function reportSellerSessionDrop(reason: string, detail?: string): void {
  if (sessionDropReported) return
  sessionDropReported = true
  Sentry.withScope((scope) => {
    scope.setLevel('warning')
    scope.setTag('session.client', 'seller-cabinet-web')
    scope.setTag('session.drop_reason', reason)
    if (detail) scope.setTag('session.drop_detail', detail)
    scope.setFingerprint(['session-drop', 'seller-cabinet-web', reason, detail ?? ''])
    Sentry.captureMessage(`Сессия сброшена (кабинет продавца): ${reason}`)
  })
}

/** Продавец сам вышел: 401 от запросов, ушедших до выхода, — не вылет. */
export function suppressSellerSessionDropReports(): void {
  sessionDropReported = true
}

export function setSentrySellerUser(userId: number | string | undefined): void {
  if (userId != null) sessionDropReported = false
  Sentry.setUser(userId != null ? { id: String(userId) } : null)
}
